import React from 'react';
import Newspaper from 'react-icons/lib/fa/newspaper-o';
import PropTypes from "prop-types";

import CardContainer from 'react/containers/CardContainer';
import Articles from 'react/views/articles/Articles';
import { getArticlesWithType } from 'data/ArticleSelector';
import { getTitleUi } from 'data/TitleInfoSelector';
import { getJsonData } from "data/DataStore";
import ArticlesFromNoveListEventTypes from 'data/types/ArticlesFromNovelistEventTypes';

const BookListsContainer = (props) => {
	return (
		<CardContainer
			{...props}
			cardModel={getArticlesWithType("Author read-alikes")
				.concat(getArticlesWithType("Book discussion guides"))
				.concat(getArticlesWithType("Curricular connections"))
				.concat(getArticlesWithType("Feature articles"))
				.concat(getArticlesWithType("Picture book extenders"))}
			component={Articles}
			icon={Newspaper}
			title="Articles from NoveList"
			countText="Related articles"
			aboutText="Browse articles related to this title"
			loggingId={getTitleUi(getJsonData())}
			eventType= {ArticlesFromNoveListEventTypes.ARTICLES_NAME_CLICKED}
		/>
	);
}

BookListsContainer.propTypes = {
	onNullRender: PropTypes.func
};

export default BookListsContainer;



// WEBPACK FOOTER //
// ./src/react/containers/ArticlesFromNovelistContainer.jsx